'use client';
import { useContext } from 'react';
import { FinancialStatusContext } from './context/financial-status-context';

export default function HeaderSection() {
	const financialContext = useContext(FinancialStatusContext);
	return (
		<div className="mx-auto mt-5 flex max-w-7xl flex-col justify-end gap-4 md:min-h-28">
			<div>
				<div className="min-h-16 text-pretty px-5 font-serif text-4xl font-bold md:px-0 md:font-semibold lg:ml-0 lg:text-5xl">
					{financialContext.language === 'en' ? 'Declaration of Financial Status' : 'Declaración de Estado Financiero'}
				</div>
			</div>
		</div>
	);
}
